// import Lottie from "lottie-web";
import Lottie from "lottie-web/build/player/lottie_light"; // no support of expression but without eval()

export class CLottieAnimation extends HTMLElement {
  lottieAnimation: any;

  connectedCallback() {
    this.lottieAnimation = Lottie.loadAnimation({
      container: this, // the dom element that will contain the animation
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.getAttribute("animation"), // the path to the animation json
    });
  }

  disconnectedCallback() {
    this.lottieAnimation.destroy();
  }
}
customElements.define("c-lottie-animation", CLottieAnimation);